import React from 'react'
import { CategorySpotlight } from '@scentregroup/shared/hub-components/category-spotlight'
import { SGPageTemplateContentCollection } from '../../../../../../src/types/page-templates'
import { ModuleProps } from '../../types'

export default function SGPageTemplateContentCollectionCategoryGridModule({
  module,
}: ModuleProps<SGPageTemplateContentCollection>): JSX.Element | null {
  if (module.items.length === 0) {
    return null
  }
  return (
    <CategorySpotlight
      title={module.title}
      text={module.shortDescription}
      items={module.items}
      analyticsSlot={module.analyticsMetadata?.displayId}
    />
  )
}
